/**
 * Der Spendenteller. Der Link kommt vom Server (PAYPAL_URL in der .env) —
 * ohne Link kein Teller.
 */
import { api } from '../api/client.js'
import { useLaden } from '../api/laden.js'

export function SpendenTeller() {
  const meta = useLaden(() => api.get<{ paypalUrl: string }>('/api/meta'))
  const url = meta.daten?.paypalUrl
  if (!url) return null

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="mt-2 block border border-messing/40 bg-bank px-4 py-3 text-center text-sm text-lampe transition-colors hover:border-messing"
    >
      🥃 Der Kammer einen ausgeben — per PayPal spenden
    </a>
  )
}
